
import { getBytesCount } from "@utils/data"


const validateCategoryIds = (rule, value, callback) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length === 0 || sum === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else if (value && getBytesCount(value) > 60) {
        callback(new Error('最多60个字符'));
    } else {
        callback();
    }
}
const validateDescrip = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (value) {
        if (regx.test(value)) {
            callback(new Error('不能含emoj表情'));
        // } else if (value.length > 0 && value.length < 20) {
        //     callback(new Error('商品描述不能少于20个字符'))
        } else if (value && value.length > 500) {
            callback(new Error('商品描述不能多于500个字符'))
        } else {
            callback();
        }
    } else {
        callback();
    }
    
}
const validateCarouselGallery = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }

    if (sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else if (context.$refs.carouselGallery) {
        let errMsg = await context.$refs.carouselGallery.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
    
}
const validateDetailGallery = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }

    if (sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else if (sum > 50) {
        callback(new Error('商品详情图最多上传50张，请移除部分图片！'))
    } else if (context.$refs.detailGallery) {
        let errMsg = await context.$refs.detailGallery.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
    
}

const validatePresaleTime = (rule, value, callback) => {
    if (value < 3 || value > 29) {
        callback(new Error('预售结束时间需设置在3-29天范围内'))
    } else {
        callback();
    }
}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    const { goodsServiceRuleMap = {} } = context;
    const { refundableRule, foltRule, lackOfWeightClaimRule } = goodsServiceRuleMap || {};
    const promiseIsRequired = (() => {
        {
            const result = {
                required: false
            }
            if (refundableRule === 2) {
                result.required = true;
                result.message = '7天无理由退换货必填';
            } else if (foltRule === 2) {
                result.required = true;
                result.message = '假一赔十必填';
            } else if (lackOfWeightClaimRule === 2) {
                result.required = true;
                result.message = '缺重包退必填';
            }
            return result;
        }
    })();
    const validatePromise = (rule, value, callback) => {
        if (refundableRule === 2  && !value.isRefundable) {
            callback(new Error('7天无理由退换货必填'))
        } else if (foltRule === 2  && !value.isFolt) {
            callback(new Error('假一赔十必填'))
        } else if (lackOfWeightClaimRule === 2  && !value.lackOfWeightClaim) {
            callback(new Error('缺重包退必填'))
        } else {
            callback();
        }
    }
    return  {
        categoryIds: [
            {required: true, message: '请选择类目', trigger: 'change'},
            {validator: validateCategoryIds}
        ],
        goodsName: [
            {required: true, message: '请输入标题', trigger: 'blur'},
            {validator: validateTitle, trigger: 'change'},
            {validator: validateTitle, trigger: 'blur'},
        ],
        goodsDesc: [
            // {required: true, message: '请输入商品描述', trigger: 'blur'},
            {validator: validateDescrip, trigger: 'change'},
        ],
        carouselGallery: [
            {required: true, message: '至少要选择1张图片'},
            {validator: contextWrap(validateCarouselGallery, context), trigger: 'change'},
        ],
        detailGallery: [
            {required: true, message: '至少要选择1张图片'},
            {validator: contextWrap(validateDetailGallery, context), trigger: 'change'},
        ],
        // marketPrice: [
        //     {required: true, message: '请输入商品市场价'},
        //     {validator: validatePrice, trigger: 'change'}
        // ],
        sizeType: [
            {required: true, message: '请选择尺码类型'}
        ],
        secondHand: [
            {required: true, message: '请选择'}
        ],
        isPreSale: [
            {required: true, message: '请选择'}
        ],
        preSaleTime: [
            {required: true, message: '请输入预售时间'},
            {validator: validatePresaleTime, trigger: 'change'}
        ],
        shipmentLimitSecond: [
            {required: true, message: '请选择承诺发货时间', trigger: 'change'}
        ],
        groupRequiredCustomerNum: [
            {required: true, message: '请输入拼单人数'}
        ],
        goodsType: [
            {required: true, message: '请选择商品类型'}
        ],
        countryId: [
            {required: true, message: '请选择货源地'}
        ],
        promise: [
            {required: promiseIsRequired.required, message: promiseIsRequired.message },
            {validator: validatePromise, trigger: 'change'}
        ]
    };
}

const validateSkuPrice = (value, prop) => {
    value = String(value).trim();
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (value === '') {
        return prop.label + '不能为空值!'
    } else if (isNaN(valueNum)) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else if (valueNum < 0) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else if (idx !== -1 &&  mStr.length > 2) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else {
        return false;
    }
    
}
export {
    RULES as default,
    validateSkuPrice
}
